import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  EntityService,
  CollectionManagerService
} from '@zerops/zef/entities';
import { AppState, ApiEntityKeys } from '@zerops/zerops/app';
import { ZefWebsocketService } from '@zerops/zef/websocket';
import { ClientBalance } from '@zerops/models/client-balance';
import { Sort } from '@zerops/zef/sort';

@Injectable({ providedIn: 'root' })
export class ClientBalanceEntity extends EntityService<ClientBalance> {

  defaultSort: Sort = {
    key: 'created',
    direction: 'desc'
  };

  list$(
    tag?: string | { name: string; id: string; },
    orderSelector: Array<string | ((i: ClientBalance) => any)> = [ this.defaultSort.key ],
    orderDir: Array<boolean | 'asc' | 'desc'> = [ this.defaultSort.direction ]
  ) {
    return super.list$(tag, orderSelector, orderDir);
  }

  constructor(
    public store: Store<AppState>,
    public collectionManager: CollectionManagerService,
    public websocketClientBalance: ZefWebsocketService
  ) {
    super(ApiEntityKeys.ClientBalance, store, collectionManager, websocketClientBalance);
  }
}
